import { VerticalSpace } from '@brokerbay/design-components';
import { Button, Col, Icon, Input, Row, Text } from 'components';
import React from 'react';

type ListingParameter = { key: string; value: string };

export type ListingInputsProps = {
  mlsType: string;
  setMlsType: React.Dispatch<React.SetStateAction<string>>;
  listingMlsNumber: string;
  setListingMlsNumber: React.Dispatch<React.SetStateAction<string>>;
  listingParameters: ListingParameter[];
  setListingParameters: React.Dispatch<
    React.SetStateAction<ListingParameter[]>
  >;
};

const ListingInput = ({
  mlsType,
  setMlsType,
  listingMlsNumber,
  setListingMlsNumber,
  listingParameters,
  setListingParameters,
}: ListingInputsProps) => (
    <VerticalSpace>
      <Text>Enter parameters of listing:</Text>
      <Row gutter={16}>
        <Col span={6}>
          <Input disabled value="mls" data-cy="testOidc-input-listingMlsKey" />
        </Col>
        <Col span={6}>
          <Input
            onChange={e => setMlsType(e.target.value)}
            value={mlsType}
            placeholder="mlsType"
            data-cy="testOidc-input-listingMlsValue"
          />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={6}>
          <Input
            disabled
            value="mlsNumber"
            data-cy="testOidc-input-listingMlsNumberKey"
          />
        </Col>
        <Col span={6}>
          <Input
            onChange={e => setListingMlsNumber(e.target.value)}
            value={listingMlsNumber}
            placeholder="Mls Number"
            data-cy="testOidc-input-listingMlsNumberValue"
          />
        </Col>
      </Row>

      {listingParameters.map(({ key, value }, index) => (
          <Row gutter={16} key={index}>
            <Col span={6}>
              <Input
                value={key}
                placeholder="key (ex: ListOfficeMlsId)"
                onChange={e => {
                  const paramKey = e.target.value;
                  setListingParameters(prev =>
                    prev
                      .slice(0, index)
                      .concat([{ value, key: paramKey }])
                      .concat(prev.slice(index + 1)),
                  );
                }}
                data-cy={`testOidc-input-listingParameterKey${index}`}
              />
            </Col>
            <Col span={6}>
              <Input
                value={value}
                placeholder="value"
                onChange={e => {
                  const paramValue = e.target.value;
                  setListingParameters(prev =>
                    prev
                      .slice(0, index)
                      .concat([{ key, value: paramValue }])
                      .concat(prev.slice(index + 1)),
                  );
                }}
                data-cy={`testOidc-input-listingParameterValue${index}`}
              />
            </Col>
            <Col span={2}>
              <Button
                onClick={() =>
                  setListingParameters(prev =>
                    prev.slice(0, index).concat(prev.slice(index + 1)),
                  )
                }
                icon={<Icon type="delete" width={14} height={14} />}
                data-cy={`testOidc-deleteListingParameter-button${index}`}
              />
            </Col>
          </Row>
        ))}
      <Row gutter={16}>
        <Col span={12}>
          <Button
            block
            onClick={() =>
              setListingParameters(prev => [...prev, { key: '', value: '' }])
            }
            data-cy="testOidc-addListingParameter-button"
          >
            Add Parameter
          </Button>
        </Col>
      </Row>
    </VerticalSpace>
  );

export default ListingInput;
